var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTexttospeechwhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 274.191,
    height: 185.476,
    viewBox: "0 0 274.191 185.476",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.225,197.527,69.37,228.174a8.063,8.063,0,0,1-12.9-6.453V194.848A76.62,76.62,0,0,1,76.627,44.311H197.582a76.609,76.609,0,0,1,0,153.219Zm26.882-64.509a12.1,12.1,0,1,0-12.1-12.1,12.1,12.1,0,0,0,12.1,12.1m-48.384,0a12.1,12.1,0,1,0-12.1-12.1v0a12.1,12.1,0,0,0,12.094,12.1Zm96.767,0a12.1,12.1,0,1,0-12.1-12.1,12.1,12.1,0,0,0,12.1,12.1Z",
    transform: "translate(0 -44.311)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTexttospeechwhite);
export default __webpack_public_path__ + "static/media/texttospeechwhite.fbdd245fd4bfb7c26c3e6e717a99025e.svg";
export { ForwardRef as ReactComponent };